import { render, staticRenderFns } from "./EditorImage.vue?vue&type=template&id=b11494f6&scoped=true&"
import script from "./EditorImage.vue?vue&type=script&lang=js&"
export * from "./EditorImage.vue?vue&type=script&lang=js&"
import style0 from "./EditorImage.vue?vue&type=style&index=0&id=b11494f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11494f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b11494f6')) {
      api.createRecord('b11494f6', component.options)
    } else {
      api.reload('b11494f6', component.options)
    }
    module.hot.accept("./EditorImage.vue?vue&type=template&id=b11494f6&scoped=true&", function () {
      api.rerender('b11494f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tinymce/components/EditorImage.vue"
export default component.exports